import script from "./Tooth12.vue?vue&type=script&setup=true&lang=js"
export * from "./Tooth12.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__